import InboxIcon from '@mui/icons-material/Inbox';
import classNames from 'classnames';
import { STREAM_SCREEN_CONFIG } from '../../config';

import { FormattedMessage } from 'react-intl';
interface Props {
  isExpanded: boolean;
}

export function NoChunks(p: Props) {
  return (
    <div
      className={classNames(
        'bg-gray-100',
        'rounded',
        'd-flex',
        'justify-content-center',
        'align-items-center',
      )}
      style={{
        height: p.isExpanded
          ? STREAM_SCREEN_CONFIG.editorHeightExpanded
          : STREAM_SCREEN_CONFIG.editorHeightCollapsed,
      }}
    >
      <div className={classNames('text-center text-gray-500', !p.isExpanded && 'font-size-sm')}>
        <InboxIcon className="mr-2" sx={{ verticalAlign: 'middle' }} />
        <FormattedMessage
          id="jointFragments.editorScreen.noChunks"
          defaultMessage="Aún no se han agregado segmentos al fragmento"
        />
      </div>
    </div>
  );
}
